import axios from "axios";

// Housekeeping API client — targets /api/hk/* and auto-injects auth:
//  · admin JWT if the caller has an admin session (/admin/pulizie/*)
//  · housekeeping PIN header if the caller is on the dedicated /pulizie route
export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/hk`,
});

api.interceptors.request.use((config) => {
  const alreadyAuth = config.headers && (config.headers.Authorization || config.headers.authorization);
  if (!alreadyAuth) {
    const token = localStorage.getItem("admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      const hkPin = sessionStorage.getItem("hk_pin");
      if (hkPin) config.headers["X-HK-PIN"] = hkPin;
    }
  }
  return config;
});
